/**
 * Main entry point for public live results app
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { loadPlausibleIfProduction } from './lib/analytics';

// Get root element and render app
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

// Staging safety (spec §5.3 / Codex #12): only fetch the real Plausible
// script in a production build, so staging traffic never reaches the
// production analytics dashboard. VITE_APP_ENV is inlined by Vite at build
// time, so this check (and the branch it skips) is resolved before the app
// ever runs on a staging or local machine.
loadPlausibleIfProduction(import.meta.env.VITE_APP_ENV);

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);

